import { InsuranceDetailsView, Overview } from '@main/blocks/overview/views';
import { OVERVIEW_DETAILS, OVERVIEW_HOME, OVERVIEW_PATH } from '@main/constants';

import { Navigate } from '@main/services-copy';

function Root() {
  return <Navigate to={`${OVERVIEW_PATH}/${OVERVIEW_HOME}`} replace />;
}

export const overviewRoutes = [
  { path: OVERVIEW_HOME, Component: Overview },
  { path: `${OVERVIEW_DETAILS}/:externalId`, Component: InsuranceDetailsView },
  { path: '', Component: Root },
];
